const personalizedInboxTabDefinitions = {
  prioritized: {
    pathSegment: 'prioritized',
    viewType: 'PRIORITIZED',
    isInOverflow: false,
    supportsReadStateFilter: false,
    showsUnreadCount: false,
  },
  mentions: {
    pathSegment: 'mentions',
    viewType: 'MENTIONS',
    isInOverflow: false,
    supportsReadStateFilter: true,
    showsUnreadCount: true,
  },
  announcements: {
    pathSegment: 'announcements',
    viewType: 'ANNOUNCEMENTS',
    isInOverflow: false,
    supportsReadStateFilter: true,
    showsUnreadCount: true,
  },
  conversations: {
    pathSegment: 'conversations',
    viewType: 'ENGAGED_CONVERSATIONS',
    isInOverflow: false,
    supportsReadStateFilter: true,
    showsUnreadCount: true,
  },
  bookmarks: {
    pathSegment: 'bookmarks',
    viewType: 'BOOKMARKS',
    isInOverflow: false,
    supportsReadStateFilter: false,
    showsUnreadCount: false,
  },
  privateMessages: {
    pathSegment: 'private-messages',
    viewType: 'DIRECT_MESSAGES',
    isInOverflow: true,
    supportsReadStateFilter: false,
    showsUnreadCount: true,
  },
  all: {
    pathSegment: 'all',
    viewType: 'ALL',
    isInOverflow: true,
    supportsReadStateFilter: false,
    showsUnreadCount: true,
  },
} as const;

export type PersonalizedInboxRouteViewType =
  (typeof personalizedInboxTabDefinitions)[PersonalizedInboxTabKey]['viewType'];
export type PersonalizedInboxTabKey = keyof typeof personalizedInboxTabDefinitions;
export type PersonalizedInboxReadStateFilter = 'ALL' | 'UNREAD';

export const personalizedInboxTabKeys: PersonalizedInboxTabKey[] = Object.keys(
  personalizedInboxTabDefinitions
) as PersonalizedInboxTabKey[];
export const personalizedInboxOverflowTabKeys: PersonalizedInboxTabKey[] = personalizedInboxTabKeys.filter(
  (key) => personalizedInboxTabDefinitions[key].isInOverflow
);
export const personalizedInboxReadStateFilterTabKeys: PersonalizedInboxTabKey[] = personalizedInboxTabKeys.filter(
  (key) => personalizedInboxTabDefinitions[key].supportsReadStateFilter
);
export const personalizedInboxUnreadCountTabKeys: PersonalizedInboxTabKey[] = personalizedInboxTabKeys.filter(
  (key) => personalizedInboxTabDefinitions[key].showsUnreadCount
);

export const getPersonalizedInboxViewTypeFromTabKey = (key: PersonalizedInboxTabKey): PersonalizedInboxRouteViewType =>
  personalizedInboxTabDefinitions[key].viewType;

export const getPersonalizedInboxPathSegmentFromTabKey = (key: PersonalizedInboxTabKey): string =>
  personalizedInboxTabDefinitions[key].pathSegment;

export const getPersonalizedInboxTabKeyFromViewType = (viewType: string): PersonalizedInboxTabKey => {
  for (const key of personalizedInboxTabKeys) {
    if (personalizedInboxTabDefinitions[key].viewType === viewType) {
      return key;
    }
  }

  throw new Error(`Unsupported Personalized Inbox view type: ${viewType}`);
};
